import React, { useEffect, useState } from "react";
import SearchTopBar from "../../components/SearchTopBar";
import TableFooter from "../../components/TableFooter";
import axios from "axios";
import ImageLoading from "../../components/ImageLoading";
import { Link, useLocation } from "react-router-dom";
import NotFoundImage from "../../images/NotFoundImage";
import NoDataFound from "../../components/NoDataFound";
import NoSearchitems from "../../components/NoSearchitems";

const GstItr = () => {
  const location = useLocation();
  const [list, setList] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [userId, setUserId] = useState("");
  const [showUserDetails, setShowUserDetails] = useState();
  const [userIndex, setUserIndex] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(rowsPerPage);
  const [selectAllCheckbox, setSelectAllCheckbox] = useState(false);
  const [checkboxes, setCheckboxes] = useState(list?.map(() => false));
  const [fullScreen, setFullScreen] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [totalRows, setTotalRows] = useState();
  const [searchPages, setSearchPages] = React.useState();
  const [searchRows, setSearchRows] = React.useState();
  const [filterShow, setFilterShow] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("name");
  const [error, setError] = useState("");
  const [companyFieldError, setCompanyFieldError] = useState("");
  const [companySelectError, setCompanySelectError] = useState("");
  const [imageLoading, setImageLoading] = useState(false);
  const filterList = ["name"];
  const token = localStorage.getItem("token");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [showNextPage, setShowNextPage] = useState(false);
  const [selectedType, setSelectedType] = useState(
    location.pathname.substring(1)
  );
  const [serachEmpty, setSearchEmpty] = useState(false);

  const displayedRows = searchList.length > 0 ? searchList : list;
  const noOfRows = searchList.length > 0 ? searchRows : totalRows;
  const noOfPages = searchList.length > 0 ? searchPages : totalPages;

  const getGSTDetails = async () => {
    searchQuery === "" && setImageLoading(true);
    try {
      const token = localStorage.getItem("token");
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/gst_itr_index?type=${selectedType}&search_field=name&search_term=${searchQuery}&page=${pageNo}&per_page=${rowsPerPage}`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      // console.log(res.data);
      setList(res.data.data);
      setSearchList(res.data.data);
      setTotalRows(res.data.total_entries);
      setTotalPages(res.data.total_pages);
      console.log(res.data.total_pages);
    } catch (error) {
      console.log(error);
    } finally {
      setImageLoading(false);
    }
  };

  useEffect(() => {
    getGSTDetails();
  }, [selectedType, pageNo, rowsPerPage, searchQuery]);

  useEffect(() => {
    setSelectedType(location.pathname.substring(1));
  }, [location]);

  const handleDownload = async (id) => {
    const token = localStorage.getItem("token");
    const options = {
      headers: { Authorization: token },
      url: `${process.env.REACT_APP_URL}/lender/download_gst_itr_as_excel?type=${selectedType}&order_id=${id}`,
      method: "GET",
    };
    const res = await axios(options);
    const csvData = res.data; // Assuming res.data is the CSV string
    // Convert the CSV data string to a Blob
    const blob = new Blob([csvData], { type: "text/csv" });
    // Create a download link
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${selectedType + "" + id}.csv`;
    link.textContent = "Download CSV";
    // Append the link to the DOM and trigger the download
    document.body.appendChild(link);
    link.click();
    // Clean up the object URL
    URL.revokeObjectURL(link.href);
    // Remove the link from the DOM
    document.body.removeChild(link);
  };

  return (
    <div className="employees">
      <div className="employees-wrap">
        {imageLoading ? (
          <>
            <SearchTopBar
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              filterList={filterList}
              filterShow={filterShow}
              setFilterShow={setFilterShow}
              selectedFilter={selectedFilter}
              setSelectedFilter={setSelectedFilter}
              downloadPageWord="assets"
            />
            <div className="w-full h-[calc(100%-106px)] flex items-center justify-center">
              <ImageLoading />
            </div>
          </>
        ) : (
          <>
            <SearchTopBar
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              filterList={filterList}
              filterShow={filterShow}
              setFilterShow={setFilterShow}
              selectedFilter={selectedFilter}
              setSelectedFilter={setSelectedFilter}
              downloadPageWord="assets"
              showButton={false}
            />
            <div className="flex my-1 items-center text-sm pl-[20px]">
              <Link
                to="/mca"
                className={`border-b ${
                  location.pathname === "/mca"
                    ? "border-[#4f46e5] bg-[#4e46e530] text-[#4f46e5]"
                    : "border-gray-400 bg-gray-100 text-gray-400"
                } px-6 py-2 cursor-pointer`}
              >
                MCA
              </Link>
              <Link
                to="/gst"
                className={`border-b ${
                  location.pathname === "/gst"
                    ? "border-[#4f46e5] bg-[#4e46e530] text-[#4f46e5]"
                    : "border-gray-400 bg-gray-100 text-gray-400"
                } px-6 py-2 cursor-pointer`}
              >
                GST
              </Link>
              <Link
                to="/itr"
                className={`border-b ${
                  location.pathname === "/itr"
                    ? "border-[#4f46e5] bg-[#4e46e530] text-[#4f46e5]"
                    : "border-gray-400 bg-gray-100 text-gray-400"
                } px-6 py-2 cursor-pointer`}
              >
                ITR
              </Link>
            </div>
            <div style={{ display: "flex", height: "calc(100% - 150px)" }}>
              <table
                className="asset-table-container"
                style={{ width: "100%" }}
                id="assets-table"
              >
                <thead className="assets-thead">
                  <tr
                    style={{
                      width: "auto",
                      justifyContent: "flex-start",
                      position: "relative",
                    }}
                  >
                    <th
                      style={{
                        width: "220px",
                        textAlign: "left",
                        display: "flex",
                        left: 0,
                      }}
                    >
                      <p style={{ left: 30, marginLeft: "20px" }}>#</p>
                      <p style={{ left: 60, marginLeft: "40px" }}>Name</p>
                    </th>
                    <th style={{ width: "250px" }}>Selected product</th>
                    <th style={{ width: "250px" }}>Pan</th>
                    <th style={{ width: "250px" }}>Status</th>
                    <th style={{ width: "250px" }}></th>
                  </tr>
                </thead>
                {searchQuery && list.length < 1 ? (
                  <>
                    <NoSearchitems />
                  </>
                ) : (
                  <>
                    {list.length ? (
                      <>
                        <tbody className="assets-tbody h-full">
                          {displayedRows?.map((i, index) => (
                            <tr
                              style={{
                                width: "auto",
                                justifyContent: "flex-start",
                              }}
                              className="relative hover:bg-[#eeeeeeb4]"
                            >
                              <td
                                style={{
                                  width: "220px",
                                  textAlign: "left",
                                  display: "flex",
                                  left: 0,
                                }}
                              >
                                <p style={{ left: 30, marginLeft: "20px" }}>
                                  {startIndex + index + 1}
                                </p>
                                <p style={{ marginLeft: "40px" }}>
                                  <span
                                    style={{
                                      color: "#0C74D4",
                                      // cursor: "pointer",
                                      left: 60,
                                      fontSize: "14px",
                                      textTransform: "capitalize",
                                      // fontWeight: 600,
                                    }}
                                  >
                                    {i.name
                                      ? i.name?.toLowerCase().slice(0, 16) +
                                        (i.name.length > 16 ? "..." : "")
                                      : "--"}
                                  </span>
                                  <br />
                                  <span style={{ fontSize: "12px" }}>
                                    {i.mobile}
                                  </span>
                                </p>
                              </td>
                              <td>{i.selected_product}</td>
                              <td>{i.pan}</td>
                              <td
                                style={{ width: "250px" }}
                                className="flex items-center justify-center"
                              >
                                <span
                                  className={`${
                                    i.status === "pending"
                                      ? "yellow-status"
                                      : i.status === "initiated"
                                      ? "blue-status"
                                      : "green-status"
                                  } px-4 rounded cursor-default flex items-center justify-center w-[100px] capitalize`}
                                >
                                  {i.status}
                                </span>
                              </td>
                              {/* <td style={{ width: "250px" }}>
                    {i.selected_products.slice(0, 2).map((d) => (
                      <p>{d}</p>
                    ))}
                    {i.selected_products?.length > 2 ? "..." : ""}
                  </td> */}
                              <td
                                className="!w-[170px] font-semibold cursor-pointer absolute text-center right-2"
                                onClick={() => {
                                  handleDownload(i.order_id);
                                }}
                              >
                                <>
                                  {selectedType === "itr" &&
                                    (i.downloadable ? (
                                      <span className="text-[#0c74d4]">
                                        Download
                                      </span>
                                    ) : (
                                      <span className="text-[#D5D5D5]">NA</span>
                                    ))}
                                  {selectedType === "gst" &&
                                    (i.download_link ? (
                                      <span className="text-[#0c74d4]">
                                        Download
                                      </span>
                                    ) : (
                                      <span className="text-[#D5D5D5]">NA</span>
                                    ))}
                                </>
                              </td>{" "}
                            </tr>
                          ))}
                        </tbody>
                      </>
                    ) : (
                      <>
                        {" "}
                        <NoDataFound insidePage={false} />
                      </>
                    )}
                  </>
                )}
              </table>
            </div>
            <TableFooter
              totalPages={totalPages}
              totalRows={noOfRows}
              rowsPerPage={rowsPerPage}
              startIndex={startIndex}
              endIndex={endIndex}
              setStartIndex={setStartIndex}
              setEndIndex={setEndIndex}
              setPageNo={setPageNo}
              pageNo={pageNo}
              setRowsPerPage={setRowsPerPage}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default GstItr;
